import { useLocation, useNavigate, useParams } from "react-router-dom";
import useConfirm from "../../hook/useConfirm";
import { useEffect, useState } from "react";
import useAuth from "../../hook/useAuth";
import baseURL from "../../config/api";
import axios from "../../config/axios";
import Select from "react-select";
import useGroup from "../../hook/useGroup";
import useSubGroup from "../../hook/useSubGroup";
import Cookies from "js-cookie";

export const EditNotification = () => {
    const token = Cookies.get("token-my-cdir");
    const { auth }: any = useAuth();
    const { selectedGroupId, isSuperAdmin }: any = useGroup();
    const { allSubGroups }: any = useSubGroup();
    const pathRoot = isSuperAdmin ? "superadmin" : "admin";
    const location = useLocation();
    const { id }: any = useParams();
    const navigate = useNavigate();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [notificationData, setNotificationData] = useState<any>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [title, setTitle] = useState<string>("");
    const [body, setBody] = useState<string>("");
    const [subGroupIds, setSubGroupIds] = useState<any>();
    const [selectedType, setSelectedType] = useState<string>("announcement");
    const [extraMessage, setExtraMessage] = useState<string>("");
    const [isSent, setIsSent] = useState<boolean>(false);
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [isRefreshTheSubGroupIds, setIsRefreshTheSubGroupIds] = useState<boolean>(false);
    const [isProcessing, setIsProcessing] = useState<boolean>(false)

    useEffect(() => {
        if (location.pathname.replace("/", "").includes(`${pathRoot}/notifications/editNotification`)) {
            setShowModal(true);
        } else {
            setShowModal(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    useEffect(() => {
        if (selectedGroupId && isRefreshTheSubGroupIds) setSubGroupIds(null);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroupId])

    useEffect(() => {
        if (showModal) {
            if (id) {
                fetch(`${baseURL}notifications/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token?.toString()}`
                    }
                })
                    .then((res) => res.json())
                    .then((data) => {
                        setNotificationData(data)
                        setTitle(data?.title)
                        setBody(data?.body)
                        const payload = JSON.parse(data?.payload)
                        setSelectedType(payload?.type ? payload?.type : "announcement")
                        setExtraMessage(payload?.type ? payload?.extraMessage : "")
                        setIsSent(data?.isSent)
                    })
                    .catch(error => console.error(error));
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, showModal])

    useEffect(() => {
        if (allSubGroups.length > 0 && isFirstTime && showModal) {
            axios
                .get(`${baseURL}notificationSubGroup/GetNotificationSubGroupsByNotificationId/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token?.toString()}`
                    }
                })
                .then((response) => {
                    const selectedSubGrops = allSubGroups?.filter((_: any) => response?.data?.find((item: any) => item?.subGroupId === _?.value));
                    if (selectedSubGrops.length > 0) {
                        setSubGroupIds(selectedSubGrops);
                    }
                    setIsFirstTime(false);
                    setIsRefreshTheSubGroupIds(true);
                })
                .catch((error) => {
                    console.error(error);
                    setIsFirstTime(false);
                    setIsRefreshTheSubGroupIds(true);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allSubGroups, showModal])

    const closeModal = () => {
        navigate(`/${pathRoot}/notifications`);
        resetState()
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (isSent) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Alert",
                summary: "Are you sure you want to send this notification.",
                confirmBtn: "Yes",
                isCancelBtn: true,
                isConfirm: (cb: any) => {
                    setIsProcessing(true);
                    axios.delete(
                        `${baseURL}notificationSubGroup/DeleteNotificationSubGroupWithNotificationId/${id},${auth?.id}`, {
                        headers: {
                            Authorization: `Bearer ${token?.toString()}`
                        }
                    })
                        .catch((error) => {
                            console.error("Error:", error);
                        });

                    axios
                        .put(
                            `${baseURL}notifications?userId=${auth?.id}&isUserTypeSender=${isSuperAdmin}`,
                            JSON.stringify({
                                id,
                                groupId: selectedGroupId,
                                title,
                                body,
                                payload: JSON.stringify({
                                    extraMessage: extraMessage,
                                    type: selectedType
                                }),
                                createdAt: new Date().toLocaleString(),
                                isSent,
                                notificationSubGroups: (Array.isArray(subGroupIds) && subGroupIds?.length > 0)
                                    ? subGroupIds?.map((item: any) => ({
                                        groupId: selectedGroupId,
                                        subGroupId: item?.value
                                    }))
                                    : []
                            }),
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${token?.toString()}`
                                },
                                withCredentials: true,
                            }
                        )
                        .then(() => {
                            navigate(`/${pathRoot}/notifications`);
                            resetState()
                            cb();
                            setIsProcessing(false);
                        })
                        .catch((error) => {
                            console.error("Error:", error);
                            setIsProcessing(false);
                        });

                },
            });
        }
        else {
            setIsProcessing(true);
            axios.delete(
                `${baseURL}notificationSubGroup/DeleteNotificationSubGroupWithNotificationId/${id},${auth?.id}`, {
                headers: {
                    Authorization: `Bearer ${token?.toString()}`
                }
            })
                .catch((error) => {
                    console.error("Error:", error);
                });

            axios
                .put(
                    `${baseURL}notifications?userId=${auth?.id}&isUserTypeSender=${isSuperAdmin}`,
                    JSON.stringify({
                        id,
                        groupId: selectedGroupId,
                        title,
                        body,
                        payload: JSON.stringify({
                            extraMessage: extraMessage,
                            type: selectedType
                        }),
                        createdAt: new Date().toLocaleString(),
                        isSent,
                        notificationSubGroups: (Array.isArray(subGroupIds) && subGroupIds?.length > 0)
                            ? subGroupIds?.map((item: any) => ({
                                groupId: selectedGroupId,
                                subGroupId: item?.value
                            }))
                            : []
                    }),
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token?.toString()}`
                        },
                        withCredentials: true,
                    }
                )
                .then(() => {
                    navigate(`/${pathRoot}/notifications`);
                    resetState();
                    setIsProcessing(false);
                })
                .catch((error) => {
                    console.error("Error:", error);
                    setIsProcessing(false);
                });
        }
    }

    const resetState = () => {
        setTitle("");
        setBody("");
        setSubGroupIds(null);
        setSelectedType("announcement")
        setExtraMessage("");
        setIsSent(false);
        setIsFirstTime(true);
        setIsProcessing(false);
    };


    return (
        <div className={`fixed inset-0 p-4 ${showModal ? "flex" : "hidden"} flex-wrap justify-center items-center w-full h-full z-[1000] bg-black bg-opacity-50`}>
            <form onSubmit={handleSubmit} className="w-full max-w-2xl bg-white shadow-lg rounded-md px-5 py-4 relative">
                <svg xmlns="http://www.w3.org/2000/svg"
                    className="w-3 cursor-pointer shrink-0 fill-[#333] hover:fill-red-500 float-right" viewBox="0 0 320.591 320.591"
                    onClick={closeModal}>
                    <path
                        d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                        data-original="#000000"></path>
                    <path
                        d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                        data-original="#000000"></path>
                </svg>
                <div className="my-2 text-center">
                    <h4 className="text-xl text-secondary font-semibold">{notificationData?.isSent ? "View" : "Edit"} Notification</h4>
                    {
                        !notificationData?.isSent && (
                            <p className="text-[12px] mt-2 bg-[#fff3c9] text-[#ffae00] text-left rounded-lg py-2 px-6">
                                If you don't selected any ministry then it will send to all the ministries.
                            </p>
                        )
                    }

                    <div className="xm:flex xm:justify-between gap-2 mb-4">
                        <div className="w-full text-sm max-xm:mt-4">
                            <label htmlFor="lastname" className="w-full text-start block text-secondary text-xs mb-2">Ministries</label>
                            {
                                notificationData?.isSent
                                    ? (
                                        <p className="w-full font-medium text-[0.75rem] text-start flex items-center flex-wrap gap-x-[0.5rem] gap-y-[0.5rem]">
                                            {
                                                allSubGroups
                                                    ?.filter((item: any) => subGroupIds?.some((id: any) => id?.value === item?.value))
                                                    ?.map((item: any, index: number) => (
                                                        <span
                                                            key={index}
                                                            className="text-xs px-2 py-1 bg-blue-100 text-custom-blue rounded-full"
                                                        >
                                                            {item?.label?.trim()}
                                                        </span>
                                                    ))
                                            }
                                        </p>
                                    ) : (
                                        <Select
                                            menuPortalTarget={document.body}
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    backgroundColor: "#ffffff",
                                                    borderRadius: '4px',
                                                    minHeight: "35px",
                                                    padding: "1px 0px",
                                                    borderWidth: "2px",
                                                    borderColor: state.isFocused ? "#3b82f6" : "#e5e7eb",
                                                    boxShadow: state.isFocused ? "0 0 0 1px #3b82f6" : "",
                                                    "&: hover": {
                                                        borderColor: "#e5e7eb",
                                                    }

                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                    backgroundColor: "#ffffff",
                                                    color: "#000000",
                                                }),
                                                option: (base, state) => {
                                                    const isSelected = state.isSelected;
                                                    const isFocused = state.isFocused;
                                                    const selectedBg = "#3b82f6";
                                                    const hoverBg = "#E6F0FA";
                                                    const defaultTextColor = "#000";

                                                    return {
                                                        ...base,
                                                        backgroundColor: isSelected
                                                            ? selectedBg
                                                            : isFocused
                                                                ? hoverBg
                                                                : "transparent",
                                                        color: isSelected ? "#fff" : defaultTextColor,
                                                        fontWeight: 500,
                                                        ':active': {
                                                            backgroundColor: isSelected ? selectedBg : hoverBg,
                                                        },
                                                    };
                                                },
                                                input: (base) => ({
                                                    ...base,
                                                    color: "#2f3739",

                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: "#2f3739",
                                                }),
                                            }}
                                            isMulti
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isLoading={false}
                                            isClearable={true}
                                            isRtl={false}
                                            isSearchable={true}
                                            name="subGroupIds"
                                            value={subGroupIds}
                                            onChange={setSubGroupIds}
                                            options={allSubGroups}
                                        />
                                    )
                            }
                        </div>
                    </div>

                    <div className="xm:flex xm:justify-between gap-2 mb-4">
                        <div className="w-full text-sm">
                            <label htmlFor="firstname" className="w-full text-start block text-secondary text-xs">Title</label>
                            {
                                notificationData?.isSent
                                    ? (
                                        <p className="font-medium text-[0.75rem] text-start">{title || "--"}</p>
                                    ) : (
                                        <input name="Title" type="text" required className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary" placeholder="Title"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    )
                            }
                        </div>

                        <div className="w-full text-sm max-xm:mt-4">
                            <label htmlFor="firstname" className="w-full text-start block text-secondary text-xs">Type</label>
                            {
                                notificationData?.isSent
                                    ? (
                                        <p className="font-medium text-[0.75rem] text-start capitalize">{selectedType || "--"}</p>
                                    ) : (
                                        <select
                                            className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                            value={selectedType}
                                            onChange={(e) => setSelectedType(e.target.value)}
                                            required
                                        >
                                            <option value="announcement">Announcement</option>
                                            <option value="reminder">Reminder</option>
                                            <option value="alert">Alert</option>
                                        </select>
                                    )
                            }
                        </div>
                    </div>

                    <div className="w-full mb-4">
                        <label className="text-start block text-secondary text-xs">Body</label>
                        {
                            notificationData?.isSent
                                ? (
                                    <p className="font-medium text-[0.75rem] text-start">{body || "--"}</p>
                                ) : (
                                    <textarea placeholder='Body'
                                        className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                        value={body}
                                        onChange={(e) => setBody(e.target.value)}
                                        required
                                    />
                                )
                        }
                    </div>

                    <div className="w-full mb-4">
                        <label className="w-full text-start block text-secondary text-xs">Extra Message</label>
                        {
                            notificationData?.isSent
                                ? (
                                    <p className="font-medium text-[0.75rem] text-start">{extraMessage || "--"}</p>
                                ) : (
                                    <textarea placeholder='Extra Message'
                                        className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                        value={extraMessage}
                                        onChange={(e) => setExtraMessage(e.target.value)}
                                    />
                                )
                        }
                    </div>

                    <div className="relative">
                        <div className="flex items-center gap-1">
                            <label className="text-start block text-secondary text-xs">
                                Sent
                            </label>

                            {/* Info Icon */}
                            <div className="relative group cursor-pointer">
                                <span className="text-gray-400 text-sm">ℹ️</span>

                                {/* Tooltip */}
                                <div className="absolute left-1/2 -translate-x-1/2 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap z-10">
                                    If you select "Yes" sends a notification (cannot be undone). If need any changes create a new one.
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center font-semibold text-sm gap-4 h-1/2 mt-1">
                            {
                                notificationData?.isSent
                                    ? (
                                        <p className="font-medium text-[0.75rem] text-start">{notificationData?.isSent ? "Yes" : "No"}</p>
                                    ) : (
                                        <>
                                            <div className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    value="Yes"
                                                    name="active"
                                                    checked={isSent === true}
                                                    onChange={(e) => setIsSent(e.target.value === "Yes")}
                                                />
                                                <label>Yes</label>
                                            </div>

                                            <div className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    value="No"
                                                    name="active"
                                                    checked={isSent === false}
                                                    onChange={(e) => setIsSent(e.target.value === "Yes")}
                                                />
                                                <label>No</label>
                                            </div>
                                        </>
                                    )
                            }
                        </div>
                    </div>
                </div>

                <div className="flex max-xm:flex-col gap-4 !mt-4">
                    <button
                        type="button"
                        className="px-6 py-2 min-w-[150px] w-full rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
                        onClick={closeModal}
                    >
                        Cancel
                    </button>

                    {
                        !notificationData?.isSent && (
                            <button
                                type="submit"
                                className="px-6 py-2 min-w-[150px] w-full rounded text-white text-sm font-semibold border-none outline-none bg-secondary hover:bg-custom-blue"
                            >
                                {isProcessing ? "Processing..." : "Save"}
                            </button>
                        )
                    }
                </div>
            </form>
        </div>
    )
}